import React from "react";

const InfoUser = () => {
  return <div>InfoUser</div>;
};

export default InfoUser;
